import React, { useContext, useState, useEffect, useRef } from 'react'

import PrimaryButton from '../../../components/atoms/PrimaryButton'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FullScreenPopup from '../../../components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '../../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CommunicationContext from '../../../context/communication/communicationContext'
import { useLocation } from 'react-router-dom'

const TemplateManage = (props) => {
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')

    const communicationContext = useContext(CommunicationContext)
    const [isLoading, setIsLoading] = useState(true)
    const [reload, setReload] = useState(false)
    const { single_static_page, getSingleStaticPage, staticPageAction } =
        communicationContext

    const reloadRef = useRef(reload)
    useEffect(() => {
        reloadRef.current = reload
    })

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        name: Yup.string().required('Required!'),
        content_type: Yup.string().required('Required!'),
        content: Yup.string().when('content_type', {
            is: 'html',
            then: Yup.string().required('Required!'),
        }),
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
        link: Yup.string().when('content_type', {
            is: 'link',
            then: Yup.string().required('Required!'),
        }),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            name: '',
            content: ' ',
            content_type: '',
            file_path: [],
            link: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.content_type == 'link') {
                values.content = ' '
                values.file_path = [values.link]
            } else if (values.content_type == 'file') {
                values.link = ''
                values.content = ' '
            } else if (values.content_type == 'html') {
                values.link = ''
                values.file_path = []
            }
            setIsLoading(true)
            // values.file_path = values.file_path[0]
            staticPageAction(values)
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    useEffect(() => {
        if (data.status === 'edit') {
            formik.values.id = data.id
            getSingleStaticPage(formik.values)
        } else {
            resetFrom()
            setIsLoading(false)
        }
    }, [data.id])

    useEffect(() => {
        if (single_static_page.record && data.status === 'edit') {
            formik.setFieldValue('id', data.id)

            const template = single_static_page.record
            template.file_path =
                template.file_path && !Array.isArray(template.file_path)
                    ? template.file_path.split(',')
                    : []

            formik.setFieldValue('name', template.name || '')
            formik.setFieldValue('content', template.content || ' ')
            formik.setFieldValue('content_type', template.content_type || '')
            formik.setFieldValue('file_path', template.file_path || [])
            formik.setFieldValue('link', template.link || '')
            setReload(!reloadRef.current)
            setIsLoading(false)
        }
    }, [single_static_page])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('name', '')
        formik.setFieldValue('content', ' ')
        formik.setFieldValue('content_type', '')
        formik.setFieldValue('file_path', [])
        formik.setFieldValue('link', '')
        setReload(!reload)
    }

    const emailTemplate = {
        formik: formik,
        data: [
            {
                label: 'Title',
                placeholder: 'Enter Title',
                class: 'col-12',
                disabled: data.status === 'new' || edit === '1' ? false : true,
                type: 'text',
                shrink: true,
                name: 'name',
            },
            {
                class: 'col-12',
                name: 'content_type',
                type: 'select',
                disabled: data.status === 'new' || edit === '1' ? false : true,
                placeholder: 'Select Content Type',
                options: [
                    { show: 'HTML', value: 'html' },
                    { show: 'FILE', value: 'file' },
                    { show: 'LINK', value: 'link' },
                ],
            },
            {
                type: 'uploadDropZone',
                name: 'file_path',
                icon: 'description',
                titleText: 'Upload Static File document',
                class: `${
                    formik.values.content_type === 'file' ? '' : 'd-none'
                } col-12`,
                folder: 'static_files',
                multiple: false,
            },
            {
                class: `${
                    formik.values.content_type === 'html' ? '' : 'd-none'
                } col-12`,
                name: 'content',
                type: global?.static_pages?.editor || 'ckeditor4',
                version: global?.static_pages?.version || 'paid',
            },
            {
                class: `${
                    formik.values.content_type === 'link' ? '' : 'd-none'
                } col-12`,
                name: 'link',
                type: 'textarea',
            },
        ],
    }

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW STATIC PAGE'
                    : `EDIT STATIC PAGE: ${single_static_page.record.name}`
            }
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        {!isLoading &&
                            ((data.status !== 'new' &&
                                formik.values.content_type === 'html' &&
                                formik.values.content) ||
                                (data.status !== 'new' &&
                                    formik.values.content_type !== 'html') ||
                                data.status === 'new') && (
                                <div className="row">
                                    {mapData(emailTemplate)}
                                </div>
                            )}
                        {isLoading && <div>Loading....</div>}
                        <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                            <SecondaryButton
                                label="Cancel"
                                id="staticPage_cancel"
                                onClick={() => toggleFullScreenPopup(false)}
                            />
                            <PrimaryButton
                                id="staticPage_submit"
                                type="submit"
                                label="Submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default TemplateManage
